import React from "react"
import i18n from "i18next"

export default function PrivacyNotice() {
  const notice = i18n.t("donation.blurb.privacy", "", { returnObjects: true })
  if (!notice) return null

  return <p className="whitespace-pre-line">{notice}</p>
}
